export default {
  summary: [],
  timesheets: [],
  settings: {
    status: [],
    projects: [],
    workcode: [],
  },
}
